import CustomPaginate from '../../../../components/PaginateComponent';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import ToggleDropdown from '../../../../components/ToogleDropdown';
import Pencil from '../../../../SVG/Pencil';
import Archive from '../../../../SVG/Archive';
import Active from '../../../../SVG/Active';
import React from 'react';
import {useTranslation} from '../../../../hooks/useTranslation';

const EquipmentArchivedTab = ({
    equipmentData,
    setCurrentId,
    currentId,
    handlePageClick,
  currentPage,
  handleUnAssign,
  handleDelete,
  handleActivate,
  handleUnarchive,
}) => {
  const {t} = useTranslation();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);
  const navigate = useNavigate();
    
    return (
      <div className='equipment__box'>
      <table className='equipment__table'>
        <thead className='equipment__table-head'>
          <tr>
            <th>{t('equipmentTable.headers.type')}</th>
            <th>{t('equipmentTable.headers.id')}</th>
            <th>{t('equipmentTable.headers.fuelType')}</th>
            <th>{t('equipmentTable.headers.facility')}</th>
            <th>{t('equipmentTable.headers.nfc')}</th>
            <th>{t('equipmentTable.headers.hoses')}</th>
            <th></th>
          </tr>
        </thead>
        <tbody
          className={`equipment__table-body ${!equipmentData?.data?.length ? 'empty' : ''}`}
        >
          {equipmentData?.data?.length ? (
            equipmentData?.data
              ?.filter(el => el?.type?.id !== 44)
              ?.map((equipment, index) => (
                <React.Fragment key={equipment?.id}>
      <tr key={equipment?.id} className='equipment__table-row'>
        <td>
          <p className='equipment__table-subtitle'>{equipment?.type?.title}</p>
        </td>
        <td>
          <p className='equipment__table-subtitle'>{equipment?.title}</p>
        </td>
        <td>
          <p className='equipment__table-subtitle'>
            {equipment?.fuel_type?.name ? equipment?.fuel_type?.name : '---'}
          </p>
        </td>
        <td>
          <p className='equipment__table-subtitle'>
            {equipment?.facility?.name}
          </p>
        </td>

        <td className='s'>
          <p className='equipment__table-title'>{t('equipmentTable.headers.nfc')}</p>
          {equipment?.beacon_address ? (
            <p className='equipment__table-subtitle'>
              <img src='/assets/icons/nfc-active.png' alt='icon' />
              <img
                src='/assets/icons/beacon-address.svg'
                onClick={() => handleUnAssign(equipment)}
                alt='icon'
              />
            </p>
          ) : (
            <p className='equipment__table-subtitle'>
              <img src='/assets/icons/nfc-inactive.png' alt='icon' />
            </p>
          )}
        </td>

        <td>
          <p className='equipment__table-subtitle'>
            {equipment?.hoses ? equipment?.hoses : '---'}
          </p>
                    </td>
        <td>
          <ToggleDropdown
            index={index}
            itemId={equipment?.id}
            selectedItem={currentId}
            setSelectedItem={setCurrentId}
            showNdxId={userInfo?.is_global}
          >
            <div
              className='equipment__table-btn blue'
              onClick={() => {
                navigate(`/equipment/edit/${equipment?.id}`, {
                  state: {equipment},
                });
              }}
            >
              <Pencil color={'#999999'}/>
              {t('equipmentTable.actions.edit')}
            </div>
            <div
                className='equipment__table-btn red'
                onClick={() => handleDelete(equipment)}
              >
                <Archive color={'#999999'}/>
                {t('equipmentTable.actions.delete')}
                        </div>
                        <div
                className='equipment__table-btn decom green'
                          onClick={() => handleUnarchive(equipment)}
              >
                <Active color={'#999999'}/>
                {t('equipmentTable.actions.unarchive')}
              </div>
          </ToggleDropdown>
        </td>
      </tr>
    </React.Fragment>
              ))
          ) : (
            <tr className='equipment__table-row empty-row'>
              <td colSpan="9" className='equipment__table-empty'>
                <div className='equipment__table-empty-content'>
                  <img src='/assets/empty-list.png' alt={t('equipmentTable.images.empty')} />
                  <p>{t('equipmentTable.messages.noArchivedEquipment')}</p>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      <CustomPaginate
        pageCount={equipmentData?.pages}
        handlePageClick={handlePageClick}
        currentPage={currentPage}
      />
    </div>
  )
};

export default EquipmentArchivedTab;
